import React from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";
import Loading from "../../Components/Loading";

import {
  SubmitBtn,
  OtherBtn,
  CancelBtn
} from "../Styles/InputStyles";
import Config from "../../Config";
import { useTranslation } from "react-i18next";

const PaymentModal = ({ openMakePaymentModel, selectedItem, serviceType, paymentApiData, assocId, refetchCNoMutate, refetchCNoLoading }) => {
  //console.log("selectedItem" , selectedItem);
  //console.log("paymentApiData" , paymentApiData);
  const { t, i18n } = useTranslation();
  const getStatus = (status) => {
    if (status == 0) {
      return <>Payment Initialised</>;
    }
    if (status == 1) {
      return <>Please proceed to pay</>;
    }if (status == 2) {
      return <>Payment Successfully completed</>;
    } 
    if (status == 3) {
      return <>C.No. Generation Error</>;
    } 
    
  };
  return (
    <Model width={"w-8/12 max-w-lg"} setOpenModel={openMakePaymentModel}>
      <Wrapper>
        
        <Title>{t("PaymentDetails")}</Title>
        <SingleItem name={"Payment For"} value={paymentApiData?.description} />
        <SingleItem name={"Fees"} value={paymentApiData?.amount} />
        <SingleItem name={"Status"} value={getStatus(paymentApiData?.status)} />
        <SingleItem name={"Remarks"} value={paymentApiData?.statusRemarks} />
        
        {
          paymentApiData?.isControlNumberFlag != 1 &&
          <>
          <SingleItem name={"Control Number"} value={"Not Generated."} />
          <SingleItem name={"Expiry Date"} value={"No Control Number" } />
          </>
        }
        {
          paymentApiData?.isControlNumberFlag == 1 &&
          <>
          <SingleItem name={"Control Number"} value={paymentApiData?.controlNumber} />
          <SingleItem name={"Expiry Date"} value={paymentApiData?.controlNumberExpDate } />
          <SubTitle>Note - Use the above control number  to pay through the mobile phone or to the bank or agent (Wakala).</SubTitle>
          </>
        }
        
        {/* <SingleItem name={"Due On"} value={"12 Jan 2023"} /> */}
        {/* {serviceType == 1 &&
        <>
        <SingleItem name={"Article No"} value={selectedItem?.articleNumber} />
        <SingleItem name={"Reason"} value={selectedItem?.reason} />
        <SingleItem name={"Status"} value={selectedItem?.status} />

        </>
        } */}

        
      </Wrapper>
      {/* {
          paymentApiData?.isControlNumberFlag != 1  && paymentApiData?.status == 0  && 
          <BtnWrapper>
          <SubmitBtn disabled={refetchCNoLoading} onClick={() => refetchCNoMutate(selectedItem)}>{refetchCNoLoading && <Loading />}
          {!refetchCNoLoading && <> Refetch Control No.</>}
          
          </SubmitBtn>
          </BtnWrapper>
        } */}

      {
          paymentApiData?.isControlNumberFlag == 1 && paymentApiData?.status != 2 &&
      <a href={Config.certificateUrl + assocId + '/' + paymentApiData?.controlNumber + ".pdf"} target="_blank" download>
      <BtnWrapper>
          <CancelBtn>{t("DownloadBill")}</CancelBtn>
      </BtnWrapper>
      </a>
      }
      {
        paymentApiData?.status == 2 &&
      <a href={Config.certificateUrl + assocId + '/' + paymentApiData?.controlNumber + "_receipt.pdf"} target="_blank" download>
      <BtnWrapper>
          <CancelBtn>{t("DownloadReceipt")}</CancelBtn>
      </BtnWrapper>
      </a>
      }
      {/* <BtnWrapper>
          <CancelBtn onClick={() => openMakePaymentModel(false)}>Close</CancelBtn>
      </BtnWrapper> */}
    </Model>
  );
};

const SingleItem = ({ name, value, link, url }) => (
  <div className="flex items-center py-2 border-b border-gray-100 ">
    <Name>{name}</Name> <p className="w-10">:</p>
    {link && (
      <LinkValue href={url} target="_blank" title="Click to open">
        {value}
      </LinkValue>
    )}
    {!link && <Value>{value}</Value>}
  </div>
);

const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl mb-6 text-gray-700 font-medium text-left`;
const SubTitle = tw.h3`text-sm text-gray-500 mt-2.5 text-left`;

const Name = tw.p`text-sm text-gray-500  w-40`;
const Value = tw.p`text-sm text-gray-800 font-medium max-w-xs `;
const LinkValue = tw.a`text-sm text-blue-500 max-w-xs truncate cursor-pointer`;
const BtnWrapper = tw.div` w-full flex items-center justify-end space-x-10 mt-8`;

export default PaymentModal;
